<div class="home-container">

  @if (isAuthenticated()) {
    <!-- Authenticated Parker Dashboard -->
    <div class="dashboard-header">
      <div class="welcome-badge">
        <span class="greeting">{{ 'DASHBOARD.WELCOME' | translate }}</span>
        <h1 class="user-name">{{ userFirstName() || 'Parker' }}</h1>
      </div>
    </div>

    <!-- Outstanding / Unpaid Payments Banner (Alert) -->
    @if (state.unpaidAmount() > 0) {
      <div class="unpaid-alert-card">
        <div class="alert-content">
          <div class="alert-icon-box">
            <mat-icon>warning</mat-icon>
          </div>
          <div class="alert-text">
            <h4>{{ 'DASHBOARD.UNPAID_TITLE' | translate }}</h4>
            <p>
              {{ 'DASHBOARD.UNPAID_TEXT' | translate: { count: state.unpaidCount() } }}
              <strong>{{ state.unpaidAmount() | currency:'EUR':'symbol':'1.2-2' }}</strong>
            </p>
          </div>
        </div>
        <jjames-button
          variant="primary"
          matIconLeft="payment"
          (clicked)="goToActivity()">
          {{ 'DASHBOARD.PAY_NOW' | translate }}
        </jjames-button>
      </div>
    }

    <!-- Active Parking Section -->
    <div class="section-container active-parking-section">
      <div class="section-title-row">
        <h3 class="section-title">
          <mat-icon class="title-icon active-dot">radio_button_checked</mat-icon>
          {{ 'DASHBOARD.ACTIVE_PARKING' | translate }}
        </h3>
        @if (!state.isActiveSessionsLoading() && state.activeSessions().length > 0) {
          <span class="active-badge">{{ state.activeSessions().length }} Active</span>
        }
      </div>

      @if (state.isActiveSessionsLoading() || state.isLoading()) {
        <div class="section-loading">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      } @else if (state.activeSessions().length > 0) {
        <div class="active-sessions-list">
          @for (session of state.activeSessions(); track session.id) {
            <app-current-parking-process [process]="session"></app-current-parking-process>
          }
        </div>
      } @else {
        <div class="no-active-card">
          <div class="icon-wrap">
            <mat-icon>local_parking</mat-icon>
          </div>
          <div class="text-wrap">
            <h4>{{ 'DASHBOARD.NO_ACTIVE' | translate }}</h4>
            <p>{{ 'DASHBOARD.NO_ACTIVE_SUB' | translate }}</p>
          </div>
        </div>
      }
    </div>

    <!-- My Vehicles Section -->
    <div class="section-container vehicles-section">
      <div class="section-title-row">
        <h3 class="section-title">
          <mat-icon class="title-icon">directions_car</mat-icon>
          {{ 'DASHBOARD.MY_VEHICLES' | translate }}
        </h3>
        <button class="text-action-btn" (click)="goToPlates()">
          {{ 'DASHBOARD.VIEW_ALL' | translate }}
        </button>
      </div>

      @if (plateRows().length === 0) {
        <div class="empty-plates-card">
          <p>{{ 'MY_PLATES.EMPTY' | translate }}</p>
          <jjames-button variant="primary" size="sm" matIconLeft="add" (clicked)="goToRegisterPlate()">
            {{ 'DASHBOARD.ADD_VEHICLE' | translate }}
          </jjames-button>
        </div>
      } @else {
        <div class="plates-grid">
          @for (plate of plateRows(); track plate.licensePlateId) {
            <div class="plate-item-card">
              <app-plate
                [number]="plate.fullNumber"
                [euBand]="plate.euBand"
                [countryCode]="plate.countryCode"
                [region]="plate.region"
                [regionSeparator]="plate.regionSeparator"
              />
            </div>
          }
        </div>
      }
    </div>

    <!-- Quick Navigation Tiles -->
    <div class="quick-nav-grid">
      <div class="nav-tile" (click)="goToActivity()">
        <div class="tile-icon-box blue">
          <mat-icon>history</mat-icon>
        </div>
        <div class="tile-content">
          <h4>{{ 'DASHBOARD.ACTIVITY' | translate }}</h4>
          <span class="tile-subtitle">
            @if (state.unpaidCount() > 0) {
              <span class="badge-alert">{{ state.unpaidCount() }} unpaid</span>
            } @else {
              <span>View all past stays</span>
            }
          </span>
        </div>
        <mat-icon class="arrow-icon">chevron_right</mat-icon>
      </div>

      <div class="nav-tile" (click)="goToEntitlements()">
        <div class="tile-icon-box green">
          <mat-icon>vpn_key</mat-icon>
        </div>
        <div class="tile-content">
          <h4>{{ 'DASHBOARD.ENTITLEMENTS' | translate }}</h4>
          <span class="tile-subtitle">{{ state.entitlements().length }} assigned areas</span>
        </div>
        <mat-icon class="arrow-icon">chevron_right</mat-icon>
      </div>
    </div>

  } @else {
    <!-- Guest / Public Flow -->
    <div class="guest-container">
      <div class="guest-header">
        <div class="logo-wrap">
          <img src="assets/logo-jjames.webp" alt="JJames Logo" class="app-logo">
        </div>
        <h1 class="guest-title">{{ 'DASHBOARD.GUEST_TITLE' | translate }}</h1>
        <p class="guest-subtitle">{{ 'DASHBOARD.GUEST_SUBTITLE' | translate }}</p>
      </div>

      <!-- Public Plate Lookup Section -->
      <div class="public-search-card">
        <app-license-plate></app-license-plate>
      </div>

      <!-- Sign In / Register Prompt -->
      <div class="guest-auth-card">
        <div class="auth-icon-box">
          <mat-icon>person</mat-icon>
        </div>
        <h3>{{ 'DASHBOARD.SIGN_IN_PROMPT' | translate }}</h3>
        <div class="auth-btn-row">
          <jjames-button variant="primary" (clicked)="login()">
            {{ 'DASHBOARD.SIGN_IN_BTN' | translate }}
          </jjames-button>
          <jjames-button variant="secondary" (clicked)="register()">
            {{ 'DASHBOARD.REGISTER_BTN' | translate }}
          </jjames-button>
        </div>
      </div>
    </div>
  }

</div>